import { Component, OnInit, NgModule, Input, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";

import { DxTreeViewTypes } from "devextreme-angular/ui/tree-view";
import { DxDrawerModule, DxDrawerTypes } from "devextreme-angular/ui/drawer";
import {
  DxScrollViewModule,
  DxScrollViewComponent,
} from "devextreme-angular/ui/scroll-view";

import {
  SideNavigationMenuModule,
  HeaderModule,
} from "../../shared/components";
import { ScreenService, ThemeService } from "../../shared/services";
import { SessionValues } from "../../services/sessionvalues.service";

@Component({
  selector: "app-side-nav-outer-toolbar",
  templateUrl: "./side-nav-outer-toolbar.component.html",
  styleUrls: ["./side-nav-outer-toolbar.component.scss"],
  standalone: false,
})
export class SideNavOuterToolbarComponent implements OnInit {
  @ViewChild(DxScrollViewComponent, { static: true })
  scrollView!: DxScrollViewComponent;
  selectedRoute = "";

  menuOpened!: boolean;
  temporaryMenuOpened = false;

  @Input()
  title!: string;

  menuMode: DxDrawerTypes.OpenedStateMode = "shrink";
  menuRevealMode: DxDrawerTypes.RevealMode = "expand";
  minMenuSize = 0;
  shaderEnabled = false;
  swatchClassName = "dx-swatch-additional";
  LoginToken: string = "";
  constructor(
    protected themeService: ThemeService,
    private screen: ScreenService,
    private router: Router,
    private sessionValues: SessionValues
  ) {
    themeService.isDark.subscribe((isDark) => {
      this.swatchClassName = "dx-swatch-additional" + (isDark ? "-dark" : "");
    });
  }

  ngOnInit() {
    this.LoginToken = this.sessionValues.CurrentLoginToken;

    this.menuOpened = this.screen.sizes["screen-large"];

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split("?")[0];
      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();
  }
  // to check wether login token is there or not //  To Avoid calling header component before login // 
  get isLoggedIn(): boolean {
    return this.LoginToken?.trim().length > 0;
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes["screen-x-small"];
    const isLarge = this.screen.sizes["screen-large"];

    this.menuMode = isLarge ? "shrink" : "overlap";
    this.menuRevealMode = isXSmall ? "slide" : "expand";
    this.minMenuSize = isXSmall ? 0 : 60;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === "overlap" || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event: any) {
    const path = (event.itemData as any).path;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      if (event.node?.selected) {
        pointerEvent?.preventDefault();
      } else {
        this.router.navigate([path]);
        this.scrollView.instance.scrollTo(0);
      }

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent?.stopPropagation();
      }
    } else {
      pointerEvent?.preventDefault();
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}

@NgModule({
  imports: [
    SideNavigationMenuModule,
    DxDrawerModule,
    HeaderModule,
    DxScrollViewModule,
    CommonModule,
  ],
  exports: [SideNavOuterToolbarComponent],
  declarations: [SideNavOuterToolbarComponent],
})
export class SideNavOuterToolbarModule { }
